export const APP_FEATURES_KEYS = [
  'show_sample_page',
  'show_user_management',
  'allow_qa_accounts_filter',
  'show_direct_collect_viewer',
  'show_threat_entity',
  'allow_threat_entity_raw_query',
  'allow_direct_collect_export',
  'show_client_metrics',
  'show_client_subscriptions',
  'rollout_opensearch_user_tokens',
  'show_cmdk_command_dialog',
  'show_infections',
  'show_bnr',
  'show_fraud_alerts',
  'allow_fa_clone',
  'allow_fa_img_upload',
  'allow_fa_check_records',
  'show_fa_special_fields',
  'show_checks_ui',
  'show_check_record_browser',
  'allow_check_record_browser_export',
  'experiment_dcv_highlight',
  'show_subscription_rollover',
  'show_breach_info',
  'show_yearly_wrapped',
  'show_cards_feedback',
  'show_cards_upload',
  'show_cards_auto_purchase',
  'allow_cards_file_content_import_save',
  'show_sources',
  'show_alert_builder',
  'allow_vertex',
  'show_banner_manager',
  'show_file_share',
  'show_portal_config',
  'show_ransomware_victim',
  'allow_stalker_free_text_autocomplete',
] as const;

export type AppFeaturesKeys = (typeof APP_FEATURES_KEYS)[number];

export type AppFeatures = {
  [K in AppFeaturesKeys]: boolean;
};

// Const object for type-safe feature flag references
export const APP_FEATURES = Object.fromEntries(
  APP_FEATURES_KEYS.map(key => [key, key])
) as { [K in AppFeaturesKeys]: K };

export const FEATURE_FLAG_ERROR_MESSAGE = 'This feature is not available';
